import { track } from "lib/analytics/core/client";
import { clearIntentId, getIntentId } from "lib/analytics/core/ids";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

export const useLoginIntent = (isInitialized: boolean) => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const authTrackedRef = useRef(false);

  useEffect(() => {
    if (!isInitialized || status === "loading") return;
    // 👇 URL에서 추적 파라미터 확인
    const parentIntentType = router.query.parentIntent as string | undefined;
    const auth = router.query.auth as string | undefined;
    // const authIntentId = router.query.authIntent as string | undefined;

    if (authTrackedRef.current) {
      return;
    }

    // 세션 스토리지에서 intent:auth 확인
    const authIntent = getIntentId("auth");
    const authIntentId = authIntent?.intentId;

    if (!authIntentId) {
      return;
    }

    // 👇 일치 확인 (같은 auth 의도인지)
    if (authIntent && authIntentId && status === "authenticated") {
      // 로그인 완료 대기
      if (status === "authenticated" && session) {
        const startTime = authIntent.createdAt || Date.now();
        const latencyMs = Date.now() - startTime;

        // ✅ Auth 성공 로깅
        track("auth_success", {
          intent_id: authIntentId,
          //   method_kind: "oauth", // 소셜 로그인
          //   provider: session.user?.provider || "kakao",
          //   mode_resolved: session.user?.isNewUser ? "signup" : "login",
          latency_ms: latencyMs,
        });

        // 정리
        clearIntentId("auth");
        authTrackedRef.current = true;

        // URL 쿼리 파라미터 제거 (깔끔하게)
        const { parentIntent, authIntent: _, ...restQuery } = router.query;
        router.replace(
          { pathname: router.pathname, query: restQuery },
          undefined,
          { shallow: true }
        );
      } else if (status === "unauthenticated") {
        // ❌ Auth 실패 로깅
        track("auth_fail", {
          intent_id: authIntentId,
          //   method_kind: "oauth",
          //   provider: "kakao",
          //   mode_resolved: "login",
          fail_reason: "authentication_failed",
        });

        console.log(`❌ [Auth] Fail tracked: authentication_failed`);

        clearIntentId("auth");
        authTrackedRef.current = true;
      }
    }
  }, [router.query, status, session, isInitialized]);

  // 페이지 변경 시 추적 상태 리셋
  useEffect(() => {
    const handleRouteChange = () => {
      authTrackedRef.current = false;
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
};
